//  font renamed as cardiuma-M - 23-08-24 - Dev Srini

const styles = theme => ({
    dashboardText2: {
        color: 'var(--b, #FFF) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    todo_list: {
        color: 'var(--b, #CEFEB8) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    indicator: {
        backgroundColor: '#F3D45E ! important',
    },

    pending_heading: {
        color: 'var(--b, #FFF) ! important',
        // fontFeatureSettings: 'clig' off  'liga' off,
        textTransform: 'none !important',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal ! important',
        fontWeight: '600 ! important',
        lineHeight: 'normal ! important',
    },

    pending_heading2: {
        color: ' var(--b, #FFF)! important',
        // width: '125px ! important',
        textAlign: 'center ! important',
        //font-feature-settings: 'clig' off, 'liga' off
        textTransform: 'none !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal ! important',
        fontWeight: '400 ! important',
        lineHeight: 'normal ! important',
        marginLeft: '4%'
    },

    campaign_heading: {
        color: ' var(--b, #FFF) ! important',
        width: '125px ! important',
        textTransform: 'none !important',
        textAlign: 'center ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal ! important',
        fontWeight: '400 ! important',
        lineHeight: '18px ! important'
    },

    tableHeading: {
        minWidth: '100px',
        width: 'auto ',
        color: 'var(--b, #747474) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important',
        whiteSpace: 'nowrap'
    },

    rowtext: {
        color: 'var(--b, #FFF)  ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px  ! important',
        fontStyle: 'normal',
        fontWeight: '400  ! important',
        lineHeight: '18px  ! important'
    },

    soundtest_heading: {
        color: 'var(--CTA, #F74542)',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '18px',
        textDecorationLine: 'underline'
    },

    modalcard: {
        width: '736px',
        height: '324px',
        flexShrink: 0,
        borderRadius: '14px',
        background: 'var(--b, #FFF)',
    },

    modalheading: {
        color: '#000',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '24px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: '18px ! important',
    },

    voicelayout: {
        width: '672px',
        height: '105px',
        flexShrink: 0,
        borderRadius: '12px',
        border: '1px solid #DFE0EB',
        background: 'var(--b, #FFF)',
    },

    voicetext: {
        color: '#000',
        fontFamily: 'cardiuma-regular',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '18px'
    },

    voiceheading: {
        color: '#000',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '18px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: '18px ! important'
    },

    rectanglebox1: {
        width: '68px',
        height: '8px',
        flexShrink: 0,
        background: '#D64A47',
        margin: '0 5px'
    },

    rectanglebox2: {
        width: '68px',
        height: '8px',
        flexShrink: 0,
        background: '#D67A47',
        margin: '0 5px'
    },

    rectanglebox3: {
        width: '68px',
        height: '8px',
        flexShrink: 0,
        background: '#D6B747',
        margin: '0 5px'
    },

    rectanglebox4: {
        width: '68px',
        height: '8px',
        flexShrink: 0,
        background: '#C2D647',
        margin: '0 5px'
    },

    rectanglebox5: {
        width: '68px',
        height: '8px',
        flexShrink: 0,
        background: '#97D647',
        margin: '0 5px'
    },

    rectanglebox6: {
        width: '68px',
        height: '8px',
        flexShrink: 0,
        background: '#F7F9FA'
    },

    voicebuttonlayout: {
        display: 'flex',
        width: '322px',
        height: '48px',
        padding: '8px 24px ! important',
        justifyContent: 'center ! important',
        alignItems: 'center ! important',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '4px ! important',
        border: '1px solid #979797 ! important',
        background: 'var(--b, #FFF)'
    },

    unclearbuttonlayout: {
        display: 'flex',
        width: '322px',
        height: '48px',
        padding: '8px 24px ! important',
        justifyContent: 'center ! important',
        alignItems: 'center ! important',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '4px ! important',
        background: 'var(--CTA, #F74542) ! important '
    },

    unclearvoicetext: {
        color: 'var(--b, #FFF)',
        fontFamily: 'cardiuma-SemiBold',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: 'normal'
    },

    breaklayout1: {
        width: '736px',
        height: '230px',
        marginTop: '270px',
        marginLeft: '370px',
        flexShrink: 0,
        borderRadius: '14px',
        background: 'var(--b, #FFF)',
    },

    breaklayout2: {
        width: '156px',
        height: '116px',
        flexShrink: 0,
        borderRadius: '14px',
        border: '1px solid #000',
        background: '#FFF'
    },

    breaktext: {
        color: '#000',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '16px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: '18px ! important'
    },

    verticaltablayout2: {
        width: '310px',
        height: '580px',
        flexShrink: 0,
        borderRadius: '8px',
        border: '1px solid #00ACFE',
        background: '#131E2E',
        // marginLeft: '100px',
        margin: '25px'
    },

    lastcall_infolayout: {
        width: '290px',
        height: '56px',
        flexShrink: 0,
        borderRadius: '4px',
        background: '#000',
    },

    mobilecard: {
        width: '308px',
        height: '502px',
        flexShrink: 0,
        backgroundColor: '#043068',
        marginTop: '15px',
        marginLeft: '10px',
        paddingTop: '1%'
    },

    mobilecard2: {
        width: '272px',
        height: '226px',
        flexShrink: 0,
        background: 'conic-gradient(from 180deg at 50% 50%, #82B9FF 0deg, #043068 100%)',
        border: '6px solid #062C5B',
        borderRadius: '15px',
        margin: '4% 0 0 4%'
    },

    mobilecard3: {
        width: '292px',
        height: '54px',
        flexShrink: 0,
        background: 'conic-gradient(from 0deg at 100% 100%, #82B9FF 0%, #043068 100%)',
        border: '6px solid #062C5B',
        borderRadius: '45px'
    },

    ongoingtext: {
        color: '#C6F465',
        textAlign: 'center',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '18px ! important',
        textTransform: 'capitalize',
        paddingTop: '43px ! important',
        paddingLeft: '108 ! important'
    },

    ongoingtext2: {
        color: 'var(--b, #FFF)',
        textAlign: 'center',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '22px ! important',
        fontStyle: 'normal',
        fontWeight: '300 ! important',
        lineHeight: '18px ! important',
        textTransform: 'capitalize',
        paddingTop: '12px ! important'
    },

    ongoingtext3: {
        color: 'var(--b, #FFF)',
        textAlign: 'center',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '32px ! important',
        fontStyle: 'normal',
        fontWeight: '100 ! important',
        lineHeight: 'normal ! important',
        textTransform: 'capitalize',
        paddingTop: '3px ! important'
    },

    message1: {
        width: '242px ! important',
        color: 'var(--b, #FFF)',
        textAlign: 'center',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '18px ! important',
        textTransform: 'capitalize'
    },

    callerModalCard: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '98%',
        height: '100%',
        borderRadius: '8px',
        border: '1px solid #00ACFE',
        background: '#131E2E'
    },

    callerInfoText: {
        color: 'var(--b, #FFF)',
        textAlign: 'center',
        fontFamily: 'cardiuma-Bold ! important',
        fontSize: '16px ! important',
        fontStyle: 'normal',
        fontWeight: '700 ! important',
        lineHeight: '18px ! important',
        textTransform: 'capitalize',
    },

    editButtonLayout: {
        width: '71px',
        height: '20px',
        flexShrink: 0,
        borderRadius: '4px',
        background: 'var(--b, #FFF)'
    },

    editText: {
        color: '#7DAB1C',
        fontFamily: 'cardiuma-Bold ! important',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: '20px'
    },

    formLabel: {
        color: '#999 ',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '10px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '20px ! important',
    },

    errtxt: {
        color: '#F74542 !important', fontFamily: 'cardiuma-regular !important', fontSize: '12px !important',
    },

    submitbuttonlayout: {
        display: 'flex ! important',
        width: '92px',
        height: '20px',
        padding: '8px 24px ! important',
        justifyContent: 'center ! important',
        alignItems: 'center ! important',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '4px ! important',
        background: 'var(--CTA, #F74542) ! important',
        marginLeft: '10px ! important'
    },

    layout2text: {
        color: 'var(--b, #FFF)',
        textAlign: 'center',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '18px ! important',
        textTransform: 'capitalize',
        marginTop: '20px ! important'
    },

    selectlayout1: {
        width: '270px! important',
        marginTop: '10px',
        flexShrink: 0,
        borderRadius: '4px',
        background: '#0B1420',

    },

    selectlayout2: {
        width: '270px ! important',
        height: '100%',
        flexShrink: 0,
        borderRadius: '4px',
        background: '#0B1420 ! important',
    },

    focused: {
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
    },

    focused1: {
        '&.MuiOutlinedInput-root,& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
    },

    callhistoryrecords1: {
        color: '#999 ',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '0px ! important',
        padding: '5px ! important'
    },

    inputtext: {
        color: '#999 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '20px'
    },

    callhistoryrecords: {
        color: '#999 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '20px ! important',
        padding: '5px ! important'
    },

    submitbuttonlayout_dis: {
        display: 'flex ! important',
        width: '92px',
        height: '20px',
        padding: '8px 24px ! important',
        justifyContent: 'center ! important',
        alignItems: 'center ! important',
        gap: '10px',
        flexShrink: 0,
        borderRadius: '4px ! important',
        background: 'var(--CTA, #999999) ! important',
        marginLeft: '10px ! important'
    },

    submitbuttontext: {
        color: 'var(--b, #FFF)',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: 'normal',

    },

    highlightedButton: {
        boxShadow: '0px 0px 10px rgba(0,0,0,0.5)',
    },

    line: {
        width: '84px',
        height: '1px',
        flexShrink: 0,
        borderRadius: '4px',
        background: '#000'
    },

    historytext: {
        color: 'var(--f, #9A9A9A) ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal ! important ',
        fontWeight: '400 ! important',
        lineHeight: 'normal ! important',
        textAlign: 'center'
    },

    datetext: {
        width: '53px',
        height: '14px',
        flexShrink: 0,
        color: '#666 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '10px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '20px ! important'
    },

    callhistorycard: {
        width: '68%',
        height: '180%',
        background: '#212D40',
        borderRadius: '4px',
        border: '1px solid #0B1420',
        marginRight: '25px',
        overflowY: "scroll",
        // display : "flex",
        // justifyContent : "center",
        alignItems: "center",
        "&::-webkit-scrollbar": {
            width: "1px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#131E2E"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#F3D45E"
        }
    },

    callhistorycard1: {
        width: '68%',
        height: '180%',
        background: '#212D40',
        borderRadius: '4px',
        border: '1px solid #0B1420',
        marginRight: '25px',
        overflowY: "scroll",
        // display : "flex",
        flexDirection: "column-reverse",
        "&::-webkit-scrollbar": {
            width: "1px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#131E2E"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#F3D45E"
        }
    },

    buttongrouptext: {
        color: '#999 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '20px ! important',
        textTransform: 'none ! important',
    },

    lastcall_text: {
        color: 'var(--b, #FFF)',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important',
        textTransform: 'capitalize'

    },

    imageContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    image: {
        width: '42px',
        height: '42px',
        flexShrink: 0,
        position: 'absolute'
    },

    containerWrapper: {
        position: 'relative', // Set relative position for the parent
        width: '50px', // Ensure wrapper has the same width as the container
        height: '50px', // Ensure wrapper has the same height as the container
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    callhistorylayout: {
        width: '250px',
        height: 'auto',
        flexShrink: 0,
        borderRadius: '4px',
        border: '1px solid #0B1420',
        background: '#131E2E',
        // marginLeft: '40px ! important',
        marginTop: '10px ! important',
        marginLeft: '15% ! important',
    },

    callhistorylayout1: {
        width: '25%',
        height: 'auto',
        flexShrink: 0,
        borderRadius: '4px',
        border: '1px solid #0B1420',
        background: '#131E2E',
        marginLeft: '10px ! important',
        marginTop: '10px ! important',
    },

    callhistorylayout2: {
        width: '63%',
        height: 'auto',
        flexShrink: 0,
        borderRadius: '4px',
        border: '1px solid #0B1420',
        background: '#131E2E',
        marginLeft: '35% ! important',
        marginTop: '10px ! important',
        alignSelf: "end"
    },

    callhistory: {
        height: "200px",
        overflowY: "scroll",
        "&::-webkit-scrollbar": {
            width: "1px",
        },
        "&::-webkit-scrollbar-track": {
            background: "#131E2E"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#F3D45E"
        }
    },

    datetext1: {
        width: '100px',
        height: '14px',
        flexShrink: 0,
        color: '#666 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '10px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        lineHeight: '20px ! important'
    },

    inputText1: {
        color: '#333333 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
    },

    statusPending: {
        color: '#FF8A00 !important',
        borderRadius: '20px!important',
        textAlign: 'center!important ',
        background: '#3D2A12 !important',
        padding: '5px 5px!important',
        fontSize: '12px !important',
    },

    statusLater: {
        color: '#7DAB1C !important',
        borderRadius: '20px!important',
        background: '#283410 !important',
        padding: '5px 5px!important',
        fontSize: '12px !important',
    },

    statusExpiry: {
        color: '#F74542 !important',
        borderRadius: '20px!important',
        textAlign: 'center!important',
        background: '#3E1A1A !important',
        padding: '5px 5px!important',
        fontSize: '12px !important',
    },

    numberButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '42px',
        height: '42px',
        flexShrink: 0,
        position: 'relative',
        border: '1px solid #ccc',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'background-color 0.3s ease',
    },

    numberHighlighted: {
        backgroundColor: '#1B559C',
    },

    dailPadClose: {
        width: '22px',
        height: '22px',
        background: '#131E2E',
        position: 'absolute',
        top: '3%',
        right: '4%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '5%',
        color: 'red',
        cursor: 'pointer',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontStyle: 'normal',
    },

    transferCallButton: {
        color: '#fff ! important',
        backgroundColor: '#01A473 ! important',
        borderRadius: '50px ! important',
        height: '43px',
        width: '163px',
        margin: '2% 0 0 24%',
        textTransform: 'none'
    },

    transferCallButtonDisable: {
        color: '#fff ! important',
        backgroundColor: '#999 ! important',
        borderRadius: '50px ! important',
        height: '43px',
        width: '163px',
        margin: '2% 0 0 24%',
        textTransform: 'none'
    },

    transferCallText: {
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: '700 ! important',
    },

    pagination: {
        '& .MuiTablePagination-select': { color: '#fff' }, // Style select dropdown text color
        '& .MuiTablePagination-toolbar': { color: 'white' }, // Style toolbar text color
        '& .MuiTablePagination-caption': { color: 'white' }, // Style caption text color
        '& .MuiTablePagination-actions': { color: 'white' }, // Style pagination actions color,
        '& .MuiSvgIcon-root.MuiTablePagination-selectIcon': {
            color: 'white', // Apply color to the select icon
        },
    },
})

export default styles
